import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Order, OrderStatus } from "../../types/orderTypes";
import { api } from "../../config/Api";



export const fetchSellerOrders = createAsyncThunk<{content:Order[];totalPages:number},{page:number; size:number}>(
    'sellerOrders/fetchSellerOrders',
    async ({page,size}, { rejectWithValue }) => {
        try {
            const response = await api.get(`/api/seller/orders?page=${page}&size=${size}`);

           
            return response.data;
        } catch (error: any) {
         
            return rejectWithValue(error.response.data);
        }
    }
);
export const updateOrderStatus = createAsyncThunk<Order, {
    orderId: number,
    orderStatus: OrderStatus
}>(
    'sellerOrders/updateOrderStatus',
    async ({ orderId, orderStatus }, { rejectWithValue }) => {
        try {
            const response = await api.patch(
                `/api/seller/orders/${orderId}/status/${orderStatus}`);
            //   the order are path variable,body, param in perspectively
           
            return response.data;
        } catch (error: any) {
          
            return rejectWithValue(error.response.data);
        }
    }
);

export const deleteOrder = createAsyncThunk<Order, number>(
    'sellerOrders/deleteOrder',
    async (orderId, { rejectWithValue }) => {
        try {
            const response = await api.patch(
                `/api/seller/orders/${orderId}/delete`);
            //   the order are path variable,body, param in perspectively
          
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

interface SellerOrderState {
    orders: Order[];
    loading: boolean;
    error: string | null;
    totalPages:number
}
const initialState: SellerOrderState = {
    orders: [],
    totalPages: 0,

    loading: false,
    error: null,

};

const sellerOrderSlice = createSlice({
    name: 'sellerOrders',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSellerOrders.pending, (state) => {
                state.loading = true;
                state.error = null;

            })
            .addCase(fetchSellerOrders.fulfilled, (state, action) => {
                state.loading = false;
                state.orders = action.payload.content;
                state.totalPages = action.payload.totalPages;
            })
            .addCase(fetchSellerOrders.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(updateOrderStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            //   map():

            // Used here to iterate through all orders and replace the one that matches updatedOrder.id with the updated order.
            // For other orders, it keeps them unchanged.
            // Why Not filter()?

            // filter() is used to exclude or include items based on a condition. In this case, you are updating an order, not removing or filtering out orders, so filter() is not appropriate.
            // Using map() in This Context:

            // map() works perfectly for updates because it returns a new array where each item is either updated or kept unchanged.
            .addCase(updateOrderStatus.fulfilled, (state, action: PayloadAction<Order>) => {
                state.loading = false;
                //shallow copies of objects or arrays and to merge properties into a new object. Let’s break it down:Spread Operator (...)
                // { ...order }: Copies all the properties of the order object.
                // { ...action.payload }: Copies all the properties of the action.payload object.
                // The resulting object combines the properties of both. If order and action.payload have the same property names, the values from action.payload override the values from order.
                state.orders = state.orders.map((order) => order.id == action.payload.id ? { ...order, ...action.payload } : order)
            })
            .addCase(updateOrderStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // delete Order
            .addCase(deleteOrder.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteOrder.fulfilled, (state, action: PayloadAction<Order>) => {
                state.loading = false;
                state.orders = state.orders.filter((order) => order.id !== action.payload.id);

            })
            .addCase(deleteOrder.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

    },
});

export const sellerOrderSliceReducer = sellerOrderSlice.reducer